import React from 'react'
import { Box, Card, CardContent, Container, Grid, Typography } from '@mui/material'
import { Architecture, Diamond, TrendingUp } from '@mui/icons-material'
import { BsMagic } from 'react-icons/bs'

const Founder = () => {

  const expertiseItems = [
        {icon: <BsMagic/>, title: 'Interior Design', years: '8+ years'},
        {icon: <Architecture/>, title: 'Home Staging', range: '$1M - $25M'},
        { icon: <TrendingUp />, title: 'Digital Marketing', expertise: 'Brand Strategy' },
        { icon: <Diamond />, title: 'Luxury Brands', sectors: 'Real Estate & Hospitality' }
    ]

    const storyItems = [
        {
            content: "I'm Juleen, the heart and mind behind Imseen Interiors. For me, design has always been a dialogue. A means of expressing who we are and how we want to live.",
            highlight: "creative force"
        },
        {
            content: "With over eight years mastering interior design, Home Staging, digital marketing, and technology, I've cultivated a unique approach that bridges imagination with intentionality.",
            stats: "8+ years"
        },
        {
            content: "My dual expertise, a Bachelor's in Interior Design paired with a Master's in Software Engineering, empowers me to move seamlessly between the tactile world of textures and the logical realm of systems.",
            highlight: "dual expertise"
        },
        {
            content: "Throughout my career, I've had the privilege of staging luxury residences valued from $1M to $25M, collaborating with premier brands across real estate, hospitality, technology, and lifestyle sectors.",
            stats: "$1M-$25M"
        },
        {
            content: "That quiet joy of entering a room that truly feels like home. The confidence of seeing your brand narrative come to life. This is the essence I design to evoke.",
            highlight: "essence I design to evoke"
        }
    ]

  return (<Box
    sx={{
      bgcolor: '#FAFAF9', minHeight: '100vh', overflow: 'hidden', position: 'relative'
    }}
   >
     <Box
      sx={{
        position: 'absolute', inset: 0, background: `
          radial-gradient(circle at 15% 85%, rgba(184,153,104,0.03) 0%, transparent 50%),
          radial-gradient(circle at 85% 15%, rgba(184,153,104,0.02) 0%, transparent 50%),
          linear-gradient(135deg, #FAFAF9 0%, #F5F3F0 100%)
        `, zIndex: 0
      }}
     />

     <Container
      maxWidth="xl"
      sx={{
        pt: { xs: 10, sm: 12, md: 16 }, pb: { xs: 6, md: 10 }, position: 'relative', zIndex: 1
      }}
     >
       <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}>
         <Typography
          variant="h1"
          sx={{
            fontSize:   { xs: '2rem', sm: '2.5rem', md: '4rem', lg: '5rem' },
            fontWeight: 300,
            color:      '#1a1a1a',
            mb:         1.5,
            fontFamily: '"Cormorant Garamond", serif',
            lineHeight: 1.05
          }}
         >
           The Vision Behind
         </Typography>

         <Box sx={{ position: 'relative', display: 'inline-block' }}>
           <Typography
            variant="h1"
            sx={{
              fontSize:   { xs: '2rem', sm: '2.5rem', md: '4rem', lg: '5rem' },
              fontWeight: 200,
              color:      '#c6a064',
              fontFamily: '"Inter", sans-serif',
              lineHeight: 1.05,
              fontStyle:  'italic'
            }}
           >
             IMSEEN INTERIORS
           </Typography>
         </Box>
       </Box>

       <Grid container spacing={{ xs: 4, md: 8 }} alignItems="flex-start">

         <Grid item xs={12} md={6} lg={5}>
           <Box
            sx={{
              position:             'relative', mb: { xs: 4, md: 6 }, '&::before': {
                content:      '""',
                position:     'absolute',
                top:          { xs: -8, md: -16 },
                left:         { xs: -8, md: -16 },
                right:        { xs: 8, md: 16 },
                bottom:       { xs: 8, md: 16 },
                border:       '1px solid #B89968',
                borderRadius: '20px',
                zIndex:       0,
                opacity:      0.28,
                transition:   'all 0.4s ease'
              }, '&:hover::before': {
                opacity: 0.6,
                top:     { xs: -10, md: -20 },
                left:    { xs: -10, md: -20 },
                right:   { xs: 10, md: 20 },
                bottom:  { xs: 10, md: 20 }
              }
            }}
           >
             <Box
              component="img"
              src="/images/founder.png"
              alt="Juleen Imseeh - Founder and Creative Director of Imseen Interiors"
              loading="lazy"
              sx={{
                width:        '100%',
                height:       'auto',
                position:     'relative',
                zIndex:       1,
                borderRadius: { xs: '16px', md: '24px' },
                filter:       'grayscale(0.1)',
                transition:   'all 0.4s ease',
                display:      'block',
                '&:hover':    {
                  transform: { xs: 'none', md: 'translate(-8px, -8px)' }
                }
              }}
             />
           </Box>

           <Card
            sx={{
              border:               '1px solid rgba(184,153,104,0.1)',
              borderRadius:         '16px',
              backdropFilter:       'blur(20px)',
              WebkitBackdropFilter: 'blur(20px)',
              boxShadow:            '0 8px 32px rgba(0,0,0,0.06)',
              background:           `
                radial-gradient(circle at 30% 50%, rgba(184,153,104,0.03) 0%, transparent 50%),
                radial-gradient(circle at 70% 80%, rgba(184,153,104,0.02) 0%, transparent 50%)
              `
            }}
           >
             <CardContent sx={{ p: { xs: 3, md: 4 } }}>
               <Typography
                variant="h6"
                sx={{
                  color:      '#1a1a1a',
                  mb:         2.5,
                  fontFamily: '"Cormorant Garamond", serif',
                  fontSize:   { xs: '1.05rem', md: '1.25rem' },
                  fontWeight: 500
                }}
               >
                 Areas of Expertise
               </Typography>

               <Grid container spacing={1}>
                 {expertiseItems.map((item, index) => (<Grid item xs={12} sm={6} key={index}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Box
                       sx={{
                         color: '#B89968', mr: 1.5, '& .MuiSvgIcon-root': { fontSize: { xs: '1rem', md: '1.25rem' } }
                       }}
                      >
                        {item.icon}
                      </Box>

                      <Box sx={{ minWidth: 0 }}>
                        <Typography
                         variant="body2"
                         sx={{
                           color:        '#1a1a1a',
                           fontWeight:   500,
                           fontSize:     { xs: '0.85rem', md: '0.95rem' },
                           overflow:     'hidden',
                           textOverflow: 'ellipsis',
                           whiteSpace:   'nowrap'
                         }}
                         title={item.title}
                        >
                          {item.title}
                        </Typography>

                        <Typography
                         variant="caption"
                         sx={{ color: '#666', fontSize: { xs: '0.72rem', md: '0.75rem' } }}
                        >
                          {item.years || item.range || item?.degree || item.expertise || item.sectors}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>))}
               </Grid>
             </CardContent>
           </Card>
         </Grid>


         <Grid item xs={12} md={6} lg={7}>
           <Box sx={{ maxWidth: { xs: '100%', md: '800px' }, ml: { md: 'auto' } }}>
             <Typography
              variant="h2"
              sx={{
                fontSize:      { xs: '1.8rem', sm: '2.2rem', md: '2.9rem', lg: '3.6rem' },
                fontWeight:    300,
                mb:            1,
                color:         '#1a1a1a',
                fontFamily:    '"Cormorant Garamond", serif',
                textAlign:     'center',
                letterSpacing: '0.02em'
              }}
             >
               Juleen Imseeh
             </Typography>

             <Typography
              variant="subtitle1"
              sx={{
                fontSize:      { xs: '0.75rem', sm: '0.85rem', md: '0.95rem' },
                color:         '#574b3a',
                mb:            { xs: 3, md: 5 },
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                fontWeight:    400,
                textAlign:     'center'
              }}
             >
               Founder & Creative Director
             </Typography>

             <Card
              sx={{
                bgcolor:      'rgba(184,153,104,0.03)',
                border:       '1px solid rgba(184,153,104,0.1)',
                borderRadius: '16px',
                p:            { xs: 3, md: 5 },
                mb:           { xs: 4, md: 6 },
                display:      'block',
                mx:           'auto',
                maxWidth:     { xs: '100%', sm: '80%', md: '100%' }
              }}
             >
               <Typography
                sx={{
                  fontSize:   { xs: '1rem', md: '1.25rem' },
                  lineHeight: 1.4,
                  color:      '#1a1a1a',
                  fontStyle:  'italic',
                  fontWeight: 300,
                  textAlign:  'center',
                  fontFamily: '"Cormorant Garamond", serif'
                }}
               >
                 "Design, to me, is never just about how something looks. It's about how it feels."
               </Typography>
             </Card>

             <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 4, md: 5 } }}>
               {storyItems.map((item, index) => (<Box
                 key={index}
                 sx={{
                   position:   'relative',
                   transition: 'all 0.3s ease',
                   '&:hover':  { transform: { xs: 'none', md: 'translateX(4px)' } }
                 }}
                >
                  <Box sx={{
                    display:       'flex',
                    gap:           2.5,
                    alignItems:    'flex-start',
                    flexDirection: { xs: 'column', sm: 'row' }
                  }}>
                    <Box
                     sx={{
                       width:          40,
                       height:         40,
                       borderRadius:   '50%',
                       bgcolor:        'rgba(184,153,104,0.1)',
                       display:        'flex',
                       alignItems:     'center',
                       justifyContent: 'center',
                       color:          '#574b3a',
                       flexShrink:     0,
                       fontSize:       '0.95rem',
                       fontWeight:     500,
                       border:         '1px solid rgba(184,153,104,0.2)'
                     }}
                    >
                      {index + 1}
                    </Box>

                    <Box sx={{ flex: 1 }}>
                      <Typography
                       sx={{
                         fontSize: { xs: '1rem', md: '1.125rem' }, lineHeight: 1.6, color: '#4a4a4a', mb: 1.5
                       }}
                      >
                        {item.highlight ? (item.content.split(item.highlight)
                          .map((part, i, arr) => i === arr.length - 1 ? (part) : (<React.Fragment key={i}>
                             {part}
                             <Box
                              component="span"
                              sx={{
                                background:   'linear-gradient(120deg, rgba(184,153,104,0.15) 0%, rgba(184,153,104,0.05) 100%)',
                                padding:      '0.08em 0.16em',
                                borderRadius: '2px',
                                fontWeight:   500,
                                color:        '#1a1a1a'
                              }}
                             >
                               {item.highlight}
                             </Box>
                           </React.Fragment>))) : (item.content)}
                      </Typography>

                      {item.stats && (<Box
                        sx={{
                          display:      'inline-flex',
                          alignItems:   'center',
                          bgcolor:      'rgba(184,153,104,0.08)',
                          color:        '#574b3a',
                          px:           2,
                          py:           0.5,
                          borderRadius: '12px',
                          fontSize:     '0.875rem',
                          fontWeight:   500
                        }}
                       >
                         {item.stats}
                       </Box>)}
                    </Box>
                  </Box>
                </Box>))}
             </Box>

             <Box
              sx={{
                textAlign: 'center',
                mt:        { xs: 6, md: 8 },
                pt:        { xs: 4, md: 6 },
                borderTop: '1px solid rgba(184,153,104,0.1)'
              }}
             >
               <Typography
                sx={{
                  fontFamily: '"Cormorant Garamond", serif',
                  fontSize:   { xs: '1.15rem', md: '1.5rem' },
                  color:      '#574b3a',
                  fontStyle:  'italic',
                  fontWeight: 300,
                  mb:         1
                }}
               >
                 Welcome to Imseen Interiors
               </Typography>

               <Typography
                sx={{ fontSize: { xs: '0.78rem', md: '0.875rem' }, color: '#B89968', letterSpacing: '0.12em' }}>
                 WHERE YOUR VISION IS TRULY SEEN
               </Typography>
             </Box>
           </Box>
         </Grid>
       </Grid>
     </Container>
   </Box>)

}

export default Founder